import { render, staticRenderFns } from "./select-fornecedor.vue?vue&type=template&id=8992a658&scoped=true"
import script from "./select-fornecedor.vue?vue&type=script&lang=ts"
export * from "./select-fornecedor.vue?vue&type=script&lang=ts"
import style0 from "./select-fornecedor.vue?vue&type=style&index=0&id=8992a658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8992a658",
  null
  
)

export default component.exports